import { render, staticRenderFns } from "./profit-report-sharing-fee.vue?vue&type=template&id=23f39c42&scoped=true&"
import script from "./profit-report-sharing-fee.vue?vue&type=script&lang=js&"
export * from "./profit-report-sharing-fee.vue?vue&type=script&lang=js&"
import style0 from "./profit-report-sharing-fee.vue?vue&type=style&index=0&id=23f39c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f39c42",
  null
  
)

export default component.exports